module.exports = __webpack_public_path__ + "img/SES_205252000.b4f78580.jpg";